const OrgApplicationStatusTypes = {
  Pending: 3,
  Returned: 4,
  Approved: 5,
  Paid: 6
};

Object.freeze(OrgApplicationStatusTypes);

export default OrgApplicationStatusTypes;